import LayoutIndex from '@/layout/LayoutIndex.vue'

const purchasesRouter = [
  {
    path: '/purchases',
    component: LayoutIndex,
    meta: { title: '采购管理', icon: 'purchases', requireAuth: true },
    name: 'purchases',
    redirect: '/purchases/purchaseOrder',
    children: [
      {
        path: '/purchases/purchaseContract',
        component: () => import('@/views/purchases/purchasesContracts/purchasesContractList.vue'),
        name: 'purchaseContract',
        meta: { title: '采购合同', requireAuth: false }
      },
      {
        path: '/purchases/purchaseContract/add',
        component: () => import('@/views/purchases/purchasesContracts/model/AddpurchasesContract.vue'),
        name: 'AddpurchasesContract',
        meta: { title: '采购合同编辑', requireAuth: false },
        hidden: true
      },
      {
        path: '/purchases/purchaseOrder',
        component: () => import('@/views/purchases/purchaseOrders/purchaseOrderList.vue'),
        name: 'purchaseOrder',
        meta: { title: '采购单', requireAuth: false }
      },
      {
        path: '/purchases/purchaseOrder/query',
        component: () => import('@/views/purchases/purchaseOrders/model/QuerypurchasesOrder.vue'),
        name: 'purchaseOrderquery',
        meta: { title: '采购单详情', requireAuth: false },
        hidden: true
      },
      {
        path: '/purchases/purchaseArrival',
        component: () => import('@/views/purchases/purchaseArrivals/PurchaseArrivalList.vue'),
        name: 'PurchaseArrivalList',
        meta: { title: '到货登记', requireAuth: false }
      },
      {
        path: '/purchases/purchaseArrival/model',
        component: () => import('@/views/purchases/purchaseArrivals/model/AddPurchaseArrival.vue'),
        name: 'AddPurchaseArrival',
        meta: { title: '到货登记编辑', requireAuth: false },
        hidden: true
      },
      {
        path: '/purchases/purchasePriceOrder',
        component: () => import('@/views/purchases/purchasePriceOrders/purchasePriceOrderList.vue'),
        name: 'purchasePriceOrder',
        meta: { title: '采购核价', requireAuth: false }
      },
      {
        path: '/purchases/purchasePriceOrder/model',
        component: () => import('@/views/purchases/purchasePriceOrders/Dtos/purchasePriceOrderDetail.vue'),
        name: 'purchasePriceOrderDetail',
        meta: { title: '采购核价详情', requireAuth: false },
        hidden: true
      },
      {
        path: '/purchases/purchaseInbound',
        component: () => import('@/views/purchases/purchaseInbounds/PurchaseInboundList.vue'),
        name: 'PurchaseInboundList',
        meta: { title: '采购入库', requireAuth: false }
      },
      {
        path: '/purchases/purchaseInbound/model',
        component: () => import('@/views/purchases/purchaseInbounds/model/AddPurchaseInbound.vue'),
        name: 'AddPurchaseInbound',
        meta: { title: '采购入库编辑', requireAuth: false },
        hidden: true
      },
      {
        path: '/purchases/purchaseInbound/detail',
        component: () => import('@/views/purchases/purchaseInbounds/model/PurchaseInboundDetail.vue'),
        name: 'PurchaseInboundDetail',
        meta: { title: '采购入库详情', requireAuth: false },
        hidden: true
      },
      {
        path: '/purchases/materialOutbound',
        component: () => import('@/views/purchases/materialOutbounds/MaterialOutboundList.vue'),
        name: 'MaterialOutboundList',
        meta: { title: '物料出库', requireAuth: false }
      },
      {
        path: '/purchases/materialOutbound/model',
        component: () => import('@/views/purchases/materialOutbounds/model/AddMaterialOutbound.vue'),
        name: 'AddMaterialOutbound',
        meta: { title: '物料出库编辑', requireAuth: false },
        hidden: true
      },
      {
        path: '/purchases/materialOutbound/detail',
        component: () => import('@/views/purchases/materialOutbounds/model/MaterialOutboundDetail.vue'),
        name: 'MaterialOutboundDetail',
        meta: { title: '物料出库详情', requireAuth: false },
        hidden: true
      },
      {
        path: '/Purchasereturn/Purchasereturn',
        component: () => import('@/views/Purchasereturn/Purchasereturn.vue'),
        name: 'purchaseReturn',
        meta: { title: '采购退货', requireAuth: false }
      },
      {
        path: '/Purchasereturn/add',
        component: () => import('@/views/Purchasereturn/model/AddPurchasereturn.vue'),
        name: 'addPurchasereturn',
        meta: { title: '采购退货编辑', requireAuth: false },
        hidden: true
      },
      {
        path: '/purchases/ShowTStockFlow',
        component: () => import('@/views/TStockFlow/ShowTStockFlow.vue'),
        name: 'MaterialInoutRecordList',
        meta: { title: '物料出入库记录', requireAuth: false }
      }
    ]
  }
]

export default purchasesRouter
